import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { DEMAND_CONTRACTS } from './contracts';

export const Route = createFileRoute('/(main)/demand')({
  component: Outlet,
  loader(ctx) {
    if (ctx.location.pathname === Route.fullPath) {
      redirect({ to: DEMAND_CONTRACTS.Route.to, throw: true });
    }
  },
});

export const DEMAND = buildRouteExport({
  Route,
});
